/**
 * Created by timkos on 08/01/17.
 */
angular.module('percipioApp').factory(
    "mobile", function($mdMedia) {
        return function(){
            return $mdMedia('max-width: 800px');
        }
    });
